import React, {
    useState,
    useRef,
    useCallback,
    useContext,
} from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import axios from 'src/api/Api';
import RecordViewContainerDesktop from './RecordViewContainerDesktop';
import RecordViewContainerMobile from './RecordViewContainerMobile';
import { sizes } from 'src/styles/Media.styled';
import PriceOverride from '../components/priceOverride';
import { localData } from '../components/addSearchItems/LocalJsonData';
import {
    clearProducts,
    searchProducts,
} from 'src/pages/scheduleSurgery/redux/actions';
import {
    setLocalSignature,
    getDropdownOptionsRequest,
    setInvalidStatus,
    setSurgeryNumber,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { checkIfValidPricedItems } from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { ReportUsageContext } from 'src/pages/reportUsage';
import BundleAddItemSearchItem from '../components/addSearchItems/BundleAddItemSearchItem';
import {
    SET_ITEMS_DURING_PRICING,
    SET_REMOVE_APPLIED_SIGNATURE,
} from 'src/pages/reportUsage/redux/action/types';
import {
    getItemTableDataWithQtyValidation,
    isQtyPresent,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { hideScrolling, resumeScrolling } from 'src/utils/util';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { pageNames, VISIBLE } from 'src/constants/appConstants';
import {
    resetBarcodeDetails,
    successMessageCamera,
} from 'src/common/barCodeScannerRedux/actions/actionCreators';
import { useTranslation } from 'react-i18next';
import { closekeyBoard } from 'src/pages/reportUsage/utils/reportUsageUtil';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const RecordViewContainer = (props) => {
    const [winWidth, setWinWidth] = useState(window.innerWidth);

    useEffectWithErrorLogging(() => {
        const handleResize = () => setWinWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        filteredProduct,
        setFilteredProduct,
        priceOverrideTableData,
        setPriceOverrideTableData,
        priceOverrideResetAllClickHandler,
        priceOverrideReason,
        setPriceOverrideReason,
        showHidePricesBtn,
        setShowHidePricesBtn,
        toggleHidePricesBtn,
        setToggleHidePricesBtn,
        pricingNotes,
        setPricingNotes,
        isAccountCardExpanded,
        setIsAccountCardExpanded,
        handleInputChange,
        accounts,
        accountId,
        AccountTemplate,
        accountValue,
        isAccountsOptionLoading,
        handleSearch,
        handleClosePopUp,
        blockedAccountMessage,
        setBlockedAccountMessage,
        handleOnfocus,
        onBlur,
        showReportPayment,
        showUnidInfoScreen,
        isReportPaymentBtnDisabled,
        currentActivity,
        showORreportScreen,
        reportPaymentBtnClickHandler,
        setreportBtnClicked,
        countryCode,
        priceOverrideReportUsageVisibility,
        setIsReportPaymentScreen,
        reportPaymentButtonVisibility,
        signatureVisibilityUsage,
    } = props;

    const [isSelected, setselected] = useState(t('reportUsage.addItems.title'));
    const [selectedProduct, setSelectedProduct] = useState('');
    const [addedProduct, setAddedProduct] = useState('');
    const [axiosSource, setAxiosSource] = useState(axios.CancelToken.source());
    const [open, setOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [isBundle] = useState(false);
    const [showBundleModal, setShowBundleModal] = useState({ show: false });
    const [selectedChildProduct, setSelectedChildProduct] = useState('');
    const [addedChildProduct, setAddedChildProduct] = useState('');
    const [numberOfSurgery, setNumberOfSurgery] = useState();
    const [addItemSearchItem, setAddItemSearchItem] = useState('');
    // Kept here so they survive the desktop/mobile container swap on rotation.
    const [bulkAddValue, setBulkAddValue] = useState('');
    const [activeScanTab, setActiveScanTab] = useState(0);
    const [externalBarcode, setExternalBarcode] = useState('');
    // const [isQtyInvalid, setIsQtyInvalid] = useState(false);

    const isPricingDone = useSelector(
        (state) => state.reportUsageRootReducer.isPricingDone
    );
    const { overrideReasons } = useSelector((state) => ({
        overrideReasons:
            state.reportUsageRootReducer.dropdownData.priceoverridereasons &&
            state.reportUsageRootReducer.dropdownData.priceoverridereasons
                .overrideReasons,
    }));
    const itemsToBePriced = useSelector(
        (state) => state.reportUsageRootReducer.itemsToBePriced
    );
    const { storedItemTableData, reportUsageObject, surgeryNumber } =
        useSelector((state) => state.reportUsageRootReducer);
    const {
        surgeryNumberReportUsageVisibility,
        surgeryNumberReportUsageMandatory,
    } = useSelector((state) => state.loginReducer);
    const isErrorExists = useSelector(
        (state) => state.reportUsageRootReducer.isErrorExists
    );
    const isQtyInvalid = useSelector(
        (state) => state.reportUsageRootReducer.isValidItem
    );
    const {
        patientInformationVisibility,
        patientIdVisibility,
        patientIdMandatory,
        reportUsagePatientDetails,
    } = useSelector((state) => state.loginReducer);

    useDynatracePageName(pageNames.reportUsageRecord);

    useEffectWithErrorLogging(() => {
        setAxiosSource(axios.CancelToken.source());
        if (!(overrideReasons && overrideReasons.length > 0)) {
            dispatch(getDropdownOptionsRequest('priceoverridereasons'));
        }
        return () => {
            dispatch({ type: SET_ITEMS_DURING_PRICING, payload: [] });
            dispatch({ type: SET_REMOVE_APPLIED_SIGNATURE, payload: false });
            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
        };
    }, []);

    const usageDetails = useContext(ReportUsageContext)?.usageDetails;
    const bundleHeadersArr =
        usageDetails?.bundleHeaders && usageDetails?.bundleHeaders.split(',');

    const unidId = usageDetails?.unidId;

    const filteredS33Products = filteredProduct?.filter((x) => {
        return x?.cfn?.startsWith('S33');
    });

    const checkIfValidBundleItem = useCallback(
        (itemId) => {
            if (itemId && bundleHeadersArr && bundleHeadersArr.length > 0) {
                const itemCFN = itemId.toUpperCase();
                return bundleHeadersArr.includes(itemCFN);
            }
            return false;
        },
        [usageDetails, addedProduct, selectedProduct]
    );

    const showBundlefromTableList = (open, index, cfn, unqId) => {
        setShowBundleModal({ show: open, index: index, cfn: cfn, unqId: unqId });
    };

    const addChildProduct = (index) => {
        setAddedChildProduct(index);
    };

    const searchedChildProduct = (index) => {
        setSelectedChildProduct(index);
    };

    const closeBundle = (val) => {
        setShowBundleModal(val);
        setShowBundleModal({ ...showBundleModal, show: val });
        setAddItemSearchItem('');
    };

    useEffectWithErrorLogging(() => {
        if (showBundleModal.show) {
            hideScrolling();
        } else {
            resumeScrolling();
        }
    }, [showBundleModal]);

    const priceOverrideClickHandler = () => {
        if (checkIfValidPricedItems(filteredProduct, true, false)) {
            props.setPriceOverride(true);
        } else {
            setIsButtonDisabled(true);
            const modifiedItemTableData =
                filteredProduct &&
                filteredProduct.length > 0 &&
                getItemTableDataWithQtyValidation(filteredProduct);
            setFilteredProduct(modifiedItemTableData);
            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
        }
    };

    const resetSelectedOrAddedItem = () => {
        setSelectedProduct('');
        setAddedProduct('');
        setSelectedChildProduct('');
        setAddedChildProduct('');
    };
    useEffectWithErrorLogging(() => {
        if (props.isPriceOverride) {
            resetSelectedOrAddedItem();
        }
    }, [props.isPriceOverride]);

    useEffectWithErrorLogging(() => {
        if (
            (isPricingDone &&
                filteredProduct.every(
                    (item) =>
                        !item.isInvalidItemMsg &&
                        (item.isBundleItem
                            ? item.children?.length > 0 &&
                              item.children.every(
                                  (child) => !child.isInvalidItemMsg
                              )
                            : true)
                )) ||
            checkIfValidPricedItems(filteredProduct, true, true)
        ) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    }, [isPricingDone, filteredProduct]);
    useEffectWithErrorLogging(() => {
        dispatch(
            setInvalidStatus(
                filteredProduct ? isQtyPresent(filteredProduct) : false
            )
        );
    }, [filteredProduct, reportUsageObject]);
    useEffectWithErrorLogging(() => {
        if (!(filteredProduct && filteredProduct[0])) {
            dispatch({ type: 'SET_ITEM_STATE_SIGNATURE', payload: [] });
            dispatch(
                setLocalSignature({ base64Image: '', dateOfSignature: '' })
            );
            setSelectedProduct('');
            setAddedProduct('');
        }
        setSelectedProduct('');
        setAddedProduct('');
    }, [filteredProduct]);
    //it will get previously added product
    const previousAddedVal = (addedProduct) => {
        const ref = useRef();
        useEffectWithErrorLogging(() => {
            ref.current = addedProduct;
        });
        return ref.current;
    };

    const previous = previousAddedVal(addedProduct);

    const showMessage = (addedProduct) => {
        //checking addedProduct State is updated or not.
        if (previous != addedProduct.value) {
            if (addedProduct.isBundle) {
                setSuccessMessage({
                    show: true,
                    message: t(
                        'consignmentReturn.billing.bundleAddedToListBelow'
                    ),
                });
            } else {
                setSuccessMessage({
                    show: true,
                    message: t(
                        'consignmentReturn.billing.itemAddedToListBelow'
                    ),
                });
            }
            setTimeout(() => setSuccessMessage(false), 2000);
        }
    };

    const messageCamera = useSelector(
        (state) => state.BarCodeScannerReducer.succesMessageCamera
    );

    useEffectWithErrorLogging(() => {
        if (messageCamera) {
            setSuccessMessage({
                show: true,
                message: t('consignmentReturn.billing.itemAddedToListBelow'),
            });
            setTimeout(() => setSuccessMessage(false), 2000);
        }
        dispatch(successMessageCamera(false));
    }, [messageCamera]);

    useEffectWithErrorLogging(() => {
        addedProduct?.value?.length > 0 && showMessage(addedProduct);
    }, [addedProduct]);

    useEffectWithErrorLogging(() => {
        selectedProduct?.value?.length > 0 && showMessage(selectedProduct);
    }, [selectedProduct]);

    const { productsList, productListLoading } = useSelector(
        (state) => ({
            productsList: state.productsSearchReducer.isBulkUpload
                ? []
                : unidId
                ? state.productsSearchReducer.products
                : state?.productsSearchReducer?.products?.filter(
                      (item) => !(item.ph2 && item.ph2.includes('H52'))
                  ),
            productListLoading: state.productsSearchReducer.loading,
        }),
        shallowEqual
    );

    const handleOnOpen = () => {
        if (addItemSearchItem && addItemSearchItem.trim().length >= 3) setOpen(true);
    };
    const cancelSearchRequest = () => {
        axiosSource?.cancel('Request cancelled');
        setAxiosSource(axios.CancelToken.source());
    };
    const onSearchAddPress = (dt) => {
        setSuccessMessage(false);
        setselected(dt);
        setBulkAddValue('');
        setActiveScanTab(0);
        setExternalBarcode('');
    };

    const updateSelectedProduct = (val, reason) => {
        if(reason === 'clear'){ 
            setAddItemSearchItem('');
            // const selectedValue={
            //         searchParam: 'all',
            //         searchTerm: val,
            //         orderType: 'ZLB',
            //         cancelSearchToken: axiosSource.token,
            //         usageTerritoryId: usageDetails?.territoryId,
            //     };
            // dispatch(
            //     searchProducts(selectedValue)
            // );
            setOpen(false);
        }
       
        if (
            val &&
            val.materialType === 'ZKMT' &&
            checkIfValidBundleItem(val.cfn)
        ) {
            const selValue={
                value: val.cfn,
                salesOrg: val.salesOrg,
                isBundle: true,
            };
            setSelectedProduct(selValue); 
        } else {
            if (
                filteredS33Products?.length >= 1 &&
                val?.cfn.startsWith('S33')
            ) {
                setSuccessMessage({
                    show: true,
                    message: t(
                        'reportUsage.procedure.unidSurgery.SurgeryOrReport.notfound'
                    ),
                });
                setTimeout(() => setSuccessMessage(false), 2000);
                return;
            }
            const selValue = {
                value: val.cfn,
                salesOrg: val.salesOrg,
                isBundle: false,
            };
            setSelectedProduct(selValue); 
        } 

        if (val) {
            const updatedProductList = [...productsList];
            if (
                !updatedProductList.find((product) => val.cfn === product.cfn)
            ) {
                updatedProductList.push({ ...val, quantity: 1 });
            }
        }
        if(val==='') setOpen(true); 
        // else {
        //     // dispatch(clearProducts());
        //     setOpen(true);
        //     cancelSearchRequest();
        // }
    };
    useEffectWithErrorLogging(() => {
        if (
            numberOfSurgery !== '' &&
            surgeryNumberReportUsageVisibility === VISIBLE &&
            numberOfSurgery !== undefined
        ) {
            dispatch(setSurgeryNumber(numberOfSurgery));
        }
    }, [numberOfSurgery]);
    useEffectWithErrorLogging(() => {
        surgeryNumber && surgeryNumberReportUsageVisibility === VISIBLE
            ? setNumberOfSurgery(parseInt(surgeryNumber))
            : surgeryNumberReportUsageVisibility === VISIBLE &&
              setNumberOfSurgery(1);
    }, []);
    
    const matchedSelectedBundleProduct = Array.isArray(filteredProduct)
        ? filteredProduct.find((product) => {
              if (!product || !showBundleModal) {
                  return false;
              } 
              return (
                  product.cfn === showBundleModal.cfn &&
                  product.unqId === showBundleModal.unqId
              );
          })
        : null;
        console.log('matchedSelectedBundleProduct', matchedSelectedBundleProduct);
    const autoCompleteInputChange = (e, value, reason) => {
        if (value) {
            if (value?.length >= 3 && reason !== 'reset') {
                setOpen(true);
                const selectedValue={
                        searchParam: 'all',
                        searchTerm: value,
                        orderType: 'ZLB',
                        cancelSearchToken: axiosSource.token,
                        usageTerritoryId: usageDetails?.territoryId,
                    };
                dispatch(
                    searchProducts(selectedValue)
                );
                setAddItemSearchItem(value);
            } else if (value?.length < 3) {
                setAddItemSearchItem(value);
            }
        } else if(reason === 'clear'){
            setOpen(false);
            cancelSearchRequest();
            setAddItemSearchItem('');
        }
    };
    const optionValue = 'description';

    const getAddedItem = (e, isScanner = false) => {
        if (isScanner) {
            let scanItemCFN = e?.productDetails?.cfn;
            let scanItemdataGTIN = e?.GTIN;
            setAddedProduct({
                value: scanItemCFN,
                isBundle: false,
                isSet: false,
                scannedGTIN: scanItemdataGTIN,
                barcodeData: e,
                isFromBundleItemScanner: false,
            });
            dispatch(resetBarcodeDetails());
        }
        if (e.key === 'Enter' || e.keyCode === 13 || e.keyCode === 9) {
            const addedCfn = e.target.value.trim();
            if (checkIfValidBundleItem(addedCfn)) {
                setAddedProduct({
                    value: addedCfn,
                    isBundle: true,
                    isSet: false,
                });
            } else {
                if (
                    filteredS33Products?.length >= 1 &&
                    addedCfn.toUpperCase().startsWith('S33')
                ) {
                    setSuccessMessage({
                        show: true,
                        message: t(
                            'reportUsage.procedure.unidSurgery.SurgeryOrReport.notfound'
                        ),
                    });
                    setTimeout(() => setSuccessMessage(false), 2000);
                    return;
                }
                setAddedProduct({
                    value: addedCfn,
                    isBundle: false,
                    isSet: false,
                });
            }
        }
    };

    const onSelectItem = (data) => {
        //checking S33 products
        if (filteredS33Products?.length >= 1 && data?.cfn.startsWith('S33')) {
            setSuccessMessage({
                show: true,
                message: t(
                    'reportUsage.procedure.unidSurgery.SurgeryOrReport.notfound'
                ),
            });
            setTimeout(() => setSuccessMessage(false), 2000);
            return;
        }
        setSelectedProduct(data.cfn);
    };

    return (
        <>
            {/* conditionally render the views */}
            {props.isPriceOverride ? (
                <PriceOverride
                    priceOverrideTableData={priceOverrideTableData}
                    setPriceOverrideTableData={setPriceOverrideTableData}
                    resetAllClickHandler={priceOverrideResetAllClickHandler}
                    priceOverrideReason={priceOverrideReason}
                    setPriceOverrideReason={setPriceOverrideReason}
                    priceOverrideReasonsList={overrideReasons}
                    itemTableData={filteredProduct}
                    pricingNotes={pricingNotes}
                    setPricingNotes={setPricingNotes}
                />
            ) : winWidth >= sizes.mediumDevice ? (
                <RecordViewContainerDesktop
                    {...props}
                    addItemSearchItem={addItemSearchItem}
                    bulkAddValue={bulkAddValue}
                    setBulkAddValue={setBulkAddValue}
                    activeScanTab={activeScanTab}
                    setActiveScanTab={setActiveScanTab}
                    externalBarcode={externalBarcode}
                    setExternalBarcode={setExternalBarcode}
                    priceOverrideReportUsageVisibility={
                        priceOverrideReportUsageVisibility
                    }
                    signatureVisibilityUsage={signatureVisibilityUsage}
                    reportUsagePatientDetails={reportUsagePatientDetails}
                    priceOverrideTableData={priceOverrideTableData}
                    itemTableData={filteredProduct}
                    isSelected={isSelected}
                    selectedProduct={selectedProduct}
                    addedProduct={addedProduct}
                    optionValue={optionValue}
                    onSearchAddPress={onSearchAddPress}
                    buttonList={localData().searchAddButton}
                    autoCompleteInputChange={autoCompleteInputChange}
                    cancelSearchRequest={cancelSearchRequest}
                    open={open}
                    setOpen={setOpen}
                    handleOnOpen={handleOnOpen}
                    onSelectItem={onSelectItem}
                    addItemChange={getAddedItem}
                    updateSelectedProduct={updateSelectedProduct}
                    productsList={productsList}
                    productListLoading={productListLoading}
                    successMessage={successMessage}
                    setSuccessMessage={setSuccessMessage}
                    toggleHidePricesBtn={toggleHidePricesBtn}
                    setToggleHidePricesBtn={setToggleHidePricesBtn}
                    showHidePricesBtn={showHidePricesBtn}
                    setShowHidePricesBtn={setShowHidePricesBtn}
                    isButtonDisabled={isButtonDisabled}
                    setIsButtonDisabled={setIsButtonDisabled}
                    isBundle={isBundle}
                    priceOverrideClickHandler={priceOverrideClickHandler}
                    filteredProduct={filteredProduct}
                    setFilteredProduct={setFilteredProduct}
                    showBundlefromTableList={showBundlefromTableList}
                    addedChildProduct={addedChildProduct}
                    selectedChildProduct={selectedChildProduct}
                    resetSelectedOrAddedItem={resetSelectedOrAddedItem}
                    priceOverrideReason={priceOverrideReason}
                    setPriceOverrideReason={setPriceOverrideReason}
                    setPricingNotes={setPricingNotes}
                    isAccountCardExpanded={isAccountCardExpanded}
                    setIsAccountCardExpanded={setIsAccountCardExpanded}
                    handleInputChange={handleInputChange}
                    accounts={accounts}
                    accountId={accountId}
                    AccountTemplate={AccountTemplate}
                    accountValue={accountValue}
                    isAccountsOptionLoading={isAccountsOptionLoading}
                    handleSearch={handleSearch}
                    handleClosePopUp={handleClosePopUp}
                    blockedAccountMessage={blockedAccountMessage}
                    setBlockedAccountMessage={setBlockedAccountMessage}
                    handleOnfocus={handleOnfocus}
                    closeKeyBoard={closekeyBoard}
                    usageDetails={usageDetails}
                    onBlur={onBlur}
                    showReportPayment={showReportPayment}
                    showUnidInfoScreen={showUnidInfoScreen}
                    isReportPaymentBtnDisabled={isReportPaymentBtnDisabled}
                    currentActivity={currentActivity}
                    showORreportScreen={showORreportScreen}
                    reportPaymentBtnClickHandler={reportPaymentBtnClickHandler}
                    setreportBtnClicked={setreportBtnClicked}
                    // setShowReportPayment={setshowReportPayment}
                    countryCode={countryCode}
                    isQtyInvalid={isQtyInvalid}
                    isErrorExists={isErrorExists}
                    setIsReportPaymentScreen={setIsReportPaymentScreen}
                    setNumberOfSurgery={setNumberOfSurgery}
                    numberOfSurgery={numberOfSurgery}
                    surgeryNumberReportUsageMandatory={
                        surgeryNumberReportUsageMandatory
                    }
                    surgeryNumberReportUsageVisibility={
                        surgeryNumberReportUsageVisibility
                    }
                />
            ) : (
                <RecordViewContainerMobile
                    {...props}
                    addItemSearchItem={addItemSearchItem}
                    bulkAddValue={bulkAddValue}
                    setBulkAddValue={setBulkAddValue}
                    activeScanTab={activeScanTab}
                    setActiveScanTab={setActiveScanTab}
                    externalBarcode={externalBarcode}
                    setExternalBarcode={setExternalBarcode}
                    setNumberOfSurgery={setNumberOfSurgery}
                    numberOfSurgery={numberOfSurgery}
                    priceOverrideReportUsageVisibility={
                        priceOverrideReportUsageVisibility
                    }
                    signatureVisibilityUsage={signatureVisibilityUsage}
                    reportPaymentButtonVisibility={
                        reportPaymentButtonVisibility
                    }
                    reportUsagePatientDetails={reportUsagePatientDetails}
                    priceOverrideTableData={priceOverrideTableData}
                    itemTableData={filteredProduct}
                    isSelected={isSelected}
                    selectedProduct={selectedProduct}
                    addedProduct={addedProduct}
                    optionValue={optionValue}
                    onSearchAddPress={onSearchAddPress}
                    buttonList={localData().searchAddButton}
                    autoCompleteInputChange={autoCompleteInputChange}
                    cancelSearchRequest={cancelSearchRequest}
                    open={open}
                    setOpen={setOpen}
                    handleOnOpen={handleOnOpen}
                    onSelectItem={onSelectItem}
                    addItemChange={getAddedItem}
                    updateSelectedProduct={updateSelectedProduct}
                    productsList={productsList}
                    productListLoading={productListLoading}
                    successMessage={successMessage}
                    setSuccessMessage={setSuccessMessage}
                    toggleHidePricesBtn={toggleHidePricesBtn}
                    setToggleHidePricesBtn={setToggleHidePricesBtn}
                    showHidePricesBtn={showHidePricesBtn}
                    setShowHidePricesBtn={setShowHidePricesBtn}
                    isButtonDisabled={isButtonDisabled}
                    priceOverrideClickHandler={priceOverrideClickHandler}
                    filteredProduct={filteredProduct}
                    setFilteredProduct={setFilteredProduct}
                    showBundlefromTableList={showBundlefromTableList}
                    addedChildProduct={addedChildProduct}
                    selectedChildProduct={selectedChildProduct}
                    resetSelectedOrAddedItem={resetSelectedOrAddedItem}
                    priceOverrideReason={priceOverrideReason}
                    setIsButtonDisabled={setIsButtonDisabled}
                    isAccountCardExpanded={isAccountCardExpanded}
                    setIsAccountCardExpanded={setIsAccountCardExpanded}
                    handleInputChange={handleInputChange}
                    accounts={accounts}
                    accountId={accountId}
                    AccountTemplate={AccountTemplate}
                    accountValue={accountValue}
                    isAccountsOptionLoading={isAccountsOptionLoading}
                    handleSearch={handleSearch}
                    handleOnfocus={handleOnfocus}
                    closeKeyBoard={closekeyBoard}
                    usageDetails={usageDetails}
                    onBlur={onBlur}
                    reportPaymentBtnClickHandler={reportPaymentBtnClickHandler}
                    setreportBtnClicked={setreportBtnClicked}
                    countryCode={countryCode}
                    itemsToBePriced={itemsToBePriced}
                    showReportPayment={showReportPayment}
                    patientIdMandatory={patientIdMandatory}
                    patientIdVisibility={patientIdVisibility}
                    patientInformationVisibility={patientInformationVisibility}
                    isQtyInvalid={isQtyInvalid}
                    isErrorExists={isErrorExists}
                    setIsReportPaymentScreen={setIsReportPaymentScreen}
                    surgeryNumberReportUsageMandatory={
                        surgeryNumberReportUsageMandatory
                    }
                    surgeryNumberReportUsageVisibility={
                        surgeryNumberReportUsageVisibility
                    }
                    setPriceOverrideReason={setPriceOverrideReason}
                    setPricingNotes={setPricingNotes}
                />
            )}
            {showBundleModal.show && (
                <BundleAddItemSearchItem
                    addItemSearchItem={addItemSearchItem}
                    setAddItemSearchItem={setAddItemSearchItem}
                    showModal={showBundleModal.show}
                    closeBundle={closeBundle}
                    selectedBundleProduct={showBundleModal}
                    addChildProduct={addChildProduct}
                    searchedChildProduct={searchedChildProduct}
                    filteredProduct={filteredProduct}
                    setFilteredProduct={setFilteredProduct}
                    matchedSelectedRUBundleProduct={matchedSelectedBundleProduct}
                    isReportUsage={true}
                />
            )}
        </>
    );
};

export default RecordViewContainer;
